export default {
  computed: {
    stateFirstName: {
      get () {
        return this.manager.first_name
      },

      set (value) {
        this.setManagerProperty({ property: 'first_name', value })
      }
    },

    stateLastName: {
      get () {
        return this.manager.last_name
      },

      set (value) {
        this.setManagerProperty({ property: 'last_name', value })
      }
    },

    stateEmail: {
      get () {
        return this.manager.email
      },

      set (value) {
        this.setManagerProperty({ property: 'email', value })
      }
    },

    stateAgency: {
      get () {
        return this.manager.agency_id
      },

      set (value) {
        this.setManagerProperty({ property: 'agency_id', value })
      }
    },

    statePhone: {
      get () {
        return this.manager.phone
      },

      set (value) {
        this.setManagerProperty({ property: 'phone', value })
      }
    }
  }
}
